import { Routes, Route } from 'react-router-dom';
import ClaimsLayout from './ClaimsLayout';
import ClaimsOverview from './ClaimsOverview';
import ClaimCreateForm from './ClaimCreateForm';

const Claims = ({ posConfig }) => {
    return (
        <Routes>
            <Route path="/" element={<ClaimsLayout />}>
                <Route index element={<ClaimsOverview posConfig={posConfig} />} />
                <Route path="create" element={<ClaimCreateForm posConfig={posConfig} />} />
            </Route>
        </Routes>
    );
};

export default Claims;
